<template>
    <v-select
        data-testid="facilities-list-menu"
        class="facilities-list-menu"
        filled
        :items="facilitiesList"
        label="Facility ID"
        item-text="name"
        item-value="value"
        v-model="alert.facility_id"
        :return-object="returnObject"
    />
</template>

<script>
import { inputRules } from "@/helpers/form-rules";
export default {
  props: ["alert", "returnObject"],

  data() {
    return {
      facilitiesList: [],
      inputRules: inputRules
    };
  },

  async created() {
    let facilities = this.$store.state.facilities.allFacilities;

    if (!facilities.length) {
      await this.$store.dispatch("getEveryFacility");
    }

    this.facilitiesList = facilities.map(facility => {
      return {
        name: facility.location_code,
        value: facility.id
      };
    });

    if (this.facilitiesList[0].name !== "Global") {
      this.facilitiesList.unshift({
        name: "Global",
        value: null
      });
    }
  }
};

</script>
